<template>
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="true" :createBtn="true" @openModalFilter="openModalFilter" @createElement="createElement"></top-navbar>
  </keep-alive>
  <section class="container-content">
    <div class="scrollable-table-container">
      <table class="orders">
        <tr class="row-title">
          <!-- Выбор заголовков -->
          <th v-for="(header, index) in headers" :key="header">
            <div class="flex-between-block th-width pointer" @click="selectSortField(index)">
              {{ header }}
              <span class="wd-sort-i">
                <!-- <img v-show="sortField == index && (sortASC || sortDESC)" src="@/assets/img/sorting.svg" /> -->
                <mdicon v-show="sortField == index && (sortASC == index || sortDESC == index)" name="swap-vertical" width="18" height="16"></mdicon>
              </span>
            </div>
          </th>
        </tr>
        <tr v-for="order in data" :key="order"> 
          <td v-for="(header, index) in headers" :key="header" :class="getCellClass(index)">
            <!-- <span v-if="index == 'status'" :class="getOrderClass(order[index])">{{ getOrderStatus(order[index]) }}</span> -->
            <span v-if="index == 'status'" :class="getOrderClass(order[index])">{{ order[index] }}</span>
            <span v-else-if="index == 'typePrice'" :class="getOrderPriceClass(order[index])">{{ getOrderPrice(order[index]) }}</span>
            <span v-else>{{ order[index] }}</span>
          </td>
        </tr>
      </table>
      
    </div>
  </section>
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
export default {
  name: 'ClaimsPage',
  components: {
    TopNavbar
  },
  data() {
    return {
      sortASC: "",
      sortDESC: "",
      sortField: "",
      selectedFields: [],
      activeTab: 'orders',
      headers: {
        num: "№ Претензии", 
        date: "Дата подачи", 
        type: "Тип", 
        status: "Статус", 
        dateRegistration: "Дата регистрации"
      },
      data: [],
      defaultData: [],
      showModalFields: false,
      showModalFilter: false
    }
  },
  mounted() {
    console.log(this.$route)
    this.init();
  },
  watch: {
    activeTab() {
      this.init()
    }
  },
  methods: {

    // Инициализация
    init() {
      this.sortASC = ""
      this.sortDESC = ""
      this.sortField = ""

      //Заполнить массив в зависимости от выбранной вкладки
      if (this.activeTab == "orders")
        this.data = [
          {
            num: "29321033091", 
            date: "05.09.2024", 
            type: "Возврат", 
            status: "В работе", 
            dateRegistration: "19.11.2023"
          },
          {
            num: "29321033091", 
            date: "05.09.2024", 
            type: "Возврат", 
            status: "В работе", 
            dateRegistration: "19.11.2023"
          },
          {
            num: "29321033091", 
            date: "05.09.2024", 
            type: "Возврат", 
            status: "В работе", 
            dateRegistration: "19.11.2023"
          }
        ]
      else
        this.data = [
          {
            num: "384939886", 
            date: "06.02.2024", 
            summ: "1 236 845,78", 
            status: "Черновик", 
            dateShip: "29.10.2023", 
            typePrice: "price", 
            typeDelivery: "Самовывоз"
          },
          {
            num: "384939888", 
            date: "08.03.2024", 
            summ: "13 610 151,00", 
            status: "В работе", 
            dateShip: "25.12.2023", 
            typePrice: "kp", 
            typeDelivery: "Самовывоз"
          },
          {
            num: "384939885", 
            date: "09.03.2024", 
            summ: "3 233 148,32", 
            status: "Черновик", 
            dateShip: "17.11.2023", 
            typePrice: "kp", 
            typeDelivery: "Самовывоз"
          },
          {
            num: "384939884", 
            date: "18.03.2024", 
            summ: "9 233 147,32", 
            status: "Согласование (Поставщик)", 
            dateShip: "20.11.2023", 
            typePrice: "price", 
            typeDelivery: "Самовывоз"
          },
          {
            num: "384939880", 
            date: "19.09.2024", 
            summ: "2 233 147,32", 
            status: "Согласование (Клиент)", 
            dateShip: "02.11.2023", 
            typePrice: "kp", 
            typeDelivery: "Самовывоз"
          }
        ]
      // Получим заказы в data
      console.log(this.data);
      // клон
      this.defaultData = JSON.parse(JSON.stringify(this.data))
    },

    // Выбор активной табы
    changeTab(tabName) {
      this.activeTab = tabName;
    },

    // Удалить фильтр по полю
    delFilter() {
      alert("Удаляем фильтр по полю");
    },

    // Определение класса для типов ячеек
    getCellClass(name) {
      if(name == "status") return "cell-status"
      else if(name == "typePrice") return "cell-price"
      else return ""
    },

    // Определение названий для ячеек статуса
    // getOrderClass(name) {
    //   if(name == "working") return "working"
    //   else if(name == "shipped") return "shipped"
    //   else if(name == "draft") return "draft"
    //   else if(name == "cancel") return "cancel"
    //   else if(name == "processingSupplier") return "processingSupplier"
    //   else if(name == "processingClient") return "processingClient"
    //   else return "default-status"
    // },
    getOrderClass(name) {
      if(name == "В работе") return "working"
      else if(name == "Отгружен") return "shipped"
      else if(name == "Черновик") return "draft"
      else if(name == "Отменен") return "cancel"
      else if(name == "Согласование (Поставщик)") return "processingSupplier"
      else if(name == "Согласование (Клиент)") return "processingClient"
      else return "default-status"
    },

    // Определение классов для ячеек статуса
    // getOrderStatus(name) {
    //   if(name == "working") return "В работе"
    //   else if(name == "shipped") return "Отгружен"
    //   else if(name == "draft") return "Черновик"
    //   else if(name == "cancel") return "Отменен"
    //   else if(name == "processingSupplier") return "Согласование (Поставщик)"
    //   else if(name == "processingClient") return "Согласование (Клиент)"
    //   else return ""
    // },

    // Определение названий для ячеек типа цены
    getOrderPrice(name) {
      if(name == "price") return "Прайс-лист"
      else if(name == "kp") return "КП"
      else return ""
    },
    // Определение классов для ячеек типа цены
    getOrderPriceClass(name) {
      if(name == "price") return "price-type"
      else if(name == "kp") return "kp-type"
      else return ""
    },

    // Закрыть модалку
    closeModal() {
      this.showModalFields = false;
      this.showModalFilter = false;
    },

    // Выбор поля для сортировки
    selectSortField(field) {
      console.log(this.defaultData)
      this.sortField = field
      if(this.sortASC != field && this.sortDESC != field) {
        this.sortASC = field
        this.data.sort(function(a, b) {
          const fieldA = a[field].toLowerCase();
          const fieldB = b[field].toLowerCase();

          if (fieldA < fieldB)  return -1;
          if (fieldA > fieldB)  return 1;
          else  return 0;
        });
      }
      else if(this.sortASC == field) {
        this.sortASC = ""
        this.sortDESC = field
        this.data.sort(function(a, b) {
          const fieldA = a[field].toLowerCase();
          const fieldB = b[field].toLowerCase();

          if (fieldA > fieldB)  return -1;
          if (fieldA < fieldB)  return 1;
          else  return 0;
        });
      }
      else if(this.sortDESC == field) {
        this.sortDESC = ""
        this.data = JSON.parse(JSON.stringify(this.defaultData))
      }
    },
    // Открыть модалку для фильтрации
    openModalFilter() {
      this.showModalFilter = true
    },

    // Создать заказ
    createElement() {
      this.$router.push('/claimCreate');
    }
  }
}
</script>
